import { Reducer } from 'redux';
import {
  SupplierBrokerActionTypes,
  SupplierBrokerState,
  GET_SUPPLIER_BROKER,
  GET_SUPPLIER_BROKER_LIST,
  POST_SUPPLIER_BROKER,
  PUT_SUPPLIER_BROKER
} from '../types/supplierbroker.types';

const initialState: SupplierBrokerState = {
  supplierBrokers: [],
  selectedSupplierBroker: null,
  postSuccess: null,
  lastFetch: null,
  totalElements: 0,
  totalPages: 1
};

export const supplierBrokerReducer: Reducer<SupplierBrokerState> = (
  state: SupplierBrokerState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as SupplierBrokerActionTypes).type) {
    case GET_SUPPLIER_BROKER_LIST:
      return {
        supplierBrokers: action.payload.page.content,
        selectedSupplierBroker: null,
        postSuccess: null,
        lastFetch: timeOfAction,
        totalElements: action.payload.page.totalElements,
        totalPages: action.payload.page.totalPages
      };
    case GET_SUPPLIER_BROKER:
      return {
        ...state,
        postSuccess: null,
        selectedSupplierBroker: action.payload.selectedSupplierBroker,
        lastFetch: timeOfAction
      };
    case POST_SUPPLIER_BROKER:
      return {
        ...state,
        postSuccess: action.payload.success,
        selectedSupplierBroker: action.payload.selectedSupplierBroker,
        lastFetch: timeOfAction
      };
    case PUT_SUPPLIER_BROKER:
      return {
        ...state,
        selectedSupplierBroker: action.payload.selectedSupplierBroker,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    default:

      return state;
  }
};
